import { httpClient } from "./http-client";
import { NewsPost } from "../pages/news/types";

export const getNews = async (customer: string): Promise<NewsPost[]> => {
  const response = await httpClient.get<NewsPost[]>(
    `customers/${encodeURIComponent(customer)}/news`
  );
  return response.data;
};
